import React from "react";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};

const cardAnim = {
  hidden: { opacity: 0, y: 25 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" }
  }
};

const ProductProcess = ({ process, headingClass }) => {
  return (
    <section className="product-process-section container">

      <motion.h3
        className="section-subheading"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Hassle-Free Use
      </motion.h3>

      <motion.h2
        className="section-heading"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        Simple Application Process
      </motion.h2>

      <motion.div
        className="process-grid"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {process.map((item, i) => (
          <motion.div
            className="process-card"
            key={i}
            variants={cardAnim}
            whileHover={{ y: -5 }} // subtle lift
            transition={{ duration: 0.2 }}
          >

            {/* IMAGE */}
            <div className="process-img">
              <motion.img
                src={item.img}
                alt={`${item.title} | VigoFlex`}
                initial={{ scale: 1.05 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              />
            </div>

            <h4 className={`card-heading ${headingClass}`}>
              {item.title}
            </h4>

            <p className="section-text">{item.desc}</p>

          </motion.div>
        ))}
      </motion.div>

    </section>
  );
};

export default ProductProcess;